import React from 'react';

const Header = () => {
    return ( 
        <>
            <div className="d-block bg-light p-4 text-center font-weight-bold display-4 shadow">
            
                <a href="#!" className="text-decoration-none text-info">Country Search</a>  
            </div>
        </>
     );
}
 
export default Header;